import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { AuthService, AuthStorageService, BaseSiteService, UserIdService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ASM_ENABLED_LOCAL_STORAGE_KEY } from '../../spartacus/features/asm/asm-constant';
import { StorageService } from '../storage/storage.service';

export interface DownloadPayload {
  type: string;
  currentPage: number;
  fields: string;
  pageSize: number;
}

@Injectable({
  providedIn: 'root',
})
export class DownloadsService {
  baseSite$: Observable<string> = this.baseService.getActive();
  occUrl = this.meta.getTag('name=occ-backend-base-url');
  url = `${this.occUrl.content}${environment.prefix}${this.baseSiteId}`;
  headers = new HttpHeaders().set('Content-Type', 'application/json');
  asmEnabled = this.storageService.getLocalStorageItem(ASM_ENABLED_LOCAL_STORAGE_KEY);
  userCurrent$: Observable<string> = this.userIdService.getUserId();

  constructor(
    private meta: Meta,
    protected http: HttpClient,
    protected auth: AuthService,
    protected baseService: BaseSiteService,
    private authStorageService: AuthStorageService,
    private userIdService: UserIdService,
    private storageService: StorageService
  ) {}
  get baseSiteId(): string {
    let baseSiteId: string;
    this.baseSite$.pipe(take(1)).subscribe((baseSiteData) => (baseSiteId = baseSiteData));
    return baseSiteId;
  }

  get userCurrent(): string {
    let userCurrent: string;
    this.userCurrent$.pipe(take(1)).subscribe((userId) => (userCurrent = userId));
    return userCurrent;
  }

  get tokenId(): string {
    let tokenId: string;
    this.authStorageService
      .getToken()
      .pipe(take(1))
      .subscribe((tokenIdData) => (tokenId = tokenIdData.access_token));
    return tokenId;
  }
  getDownload(payload: DownloadPayload): Observable<any> {
    const asmQuery = this.asmEnabled ? `?asmUser=${this.userCurrent}` : '';
    const params = new HttpParams()
      .set('currentPage', payload.currentPage as any)
      .set('fields', payload.fields)
      .set('pageSize', payload.pageSize as any)
      .set('type', payload.type);

    return this.http
      .get(`${this.url}/downloads/search`, {
        params,
        headers: this.headers,
      })
      .pipe(map((data) => data));
  }
}
